var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCondo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.1 20.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #8b8c9e;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #8b8c9d;\n        stroke-width: .96px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.38,
    y: 2.67,
    width: 15.03,
    height: 17.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.19,
    y: 0.5,
    width: 17.42,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.79,
    y: 15.57,
    width: 2.21,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 15.57,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.05,
    y: 15.57,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 10.48,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.79,
    y: 10.48,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.05,
    y: 10.48,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 5.33,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.82,
    y: 10.48,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.82,
    y: 15.57,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.79,
    y: 5.33,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.05,
    y: 5.33,
    width: 2.21,
    height: 2.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.38 20.12 .48 20.12 .48 9.03 7.38 6.21 7.38 20.12"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondo);
export default __webpack_public_path__ + "static/media/Condo.0f23dc6c.svg";
export { ForwardRef as ReactComponent };